<div class="account-pages my-5 pt-sm-5">
  <div class="container">
    <div class="row align-items-center justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center mt-2">
              <h3 class="text-muted">Sign in to continue to Aggne Exam Portal.</h3>
            </div>

            <div [ngClass]="{'alert': true, 'text-center': true, 'mt-4': true,
                           'alert-danger': examStatus.type === 'expired' || examStatus.type === 'invalid' || examStatus.type === 'submitted',
                           'alert-warning': examStatus.type === 'not-started'}"
                 *ngIf="!examStatus.isValid">
              {{ examStatus.message }}
            </div>

            <div class="p-2 mt-4" *ngIf="examStatus.isValid">
              <form [formGroup]="loginForm" (ngSubmit)="onLogin()" novalidate>
                <div class="mb-3">
                  <label class="form-label" for="name">Name</label>
                  <input type="text" class="form-control" formControlName="name" id="name" placeholder="Enter Name">
                  <div *ngIf="loginForm.get('name')?.touched && loginForm.get('name')?.invalid" class="text-danger">
                    Name is required.
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label" for="email">Email</label>
                  <input type="text" class="form-control" formControlName="email" id="email" placeholder="Enter Email">
                  <div *ngIf="loginForm.get('email')?.touched && loginForm.get('email')?.invalid" class="text-danger">
                    <div *ngIf="loginForm.get('email')?.errors?.['required']">Email is required.</div>
                    <div *ngIf="loginForm.get('email')?.errors?.['pattern']">Enter a valid email address.</div>
                  </div>
                </div>

                <div class="mb-3">
                  <label class="form-label" for="phoneNumber">Phone</label>
                  <input type="text" class="form-control" formControlName="phoneNumber" id="phoneNumber" 
                         placeholder="Enter Phone Number">
                  <div *ngIf="loginForm.get('phoneNumber')?.touched && loginForm.get('phoneNumber')?.invalid" class="text-danger">
                    <div *ngIf="loginForm.get('phoneNumber')?.errors?.['required']">Phone number is required.</div>
                    <div *ngIf="loginForm.get('phoneNumber')?.errors?.['pattern'] || loginForm.get('phoneNumber')?.errors?.['minlength']">
                      Phone number must be at least 10 digits.
                    </div>
                  </div>
                </div>

                <div class="mt-3 text-end">
                  <button class="btn btn-primary w-sm waves-effect waves-light" type="submit">Enter</button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="mt-5 text-center">
          <p>© {{currentYear}} Aggne Global It Services.</p>
        </div>
      </div>
    </div>
  </div>
</div>